/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitFuelPurchaseResponse
 */
export interface SubmitFuelPurchaseResponse {
    /**
     * Payment intent created but still requires action to complete.
     * @type {string}
     * @memberof SubmitFuelPurchaseResponse
     */
    nextAction?: string;
}

/**
 * Check if a given object implements the SubmitFuelPurchaseResponse interface.
 */
export function instanceOfSubmitFuelPurchaseResponse(value: object): value is SubmitFuelPurchaseResponse {
    return true;
}

export function SubmitFuelPurchaseResponseFromJSON(json: any): SubmitFuelPurchaseResponse {
    return SubmitFuelPurchaseResponseFromJSONTyped(json, false);
}

export function SubmitFuelPurchaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitFuelPurchaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nextAction': json['nextAction'] == null ? undefined : json['nextAction'],
    };
}

export function SubmitFuelPurchaseResponseToJSON(json: any): SubmitFuelPurchaseResponse {
    return SubmitFuelPurchaseResponseToJSONTyped(json, false);
}

export function SubmitFuelPurchaseResponseToJSONTyped(value?: SubmitFuelPurchaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nextAction': value['nextAction'],
    };
}

